import {
  deburr, isFunction, isString, join, map,
} from 'lodash';
import type {
  Location, UnderscoredLongLocation, UnderscoredShortLocation, UnknownLocation,
} from './interfaces';

/**
 * @param hashParams
 * @returns {string} the locationHash
 */
export const generateLocationHash = (hashParams: unknown): string => {
  const HASH_SEPARATOR = '@';

  const params = hashParams as any;

  return join(map(params, (value, key) => `${key}${HASH_SEPARATOR}${deburr(value)}`), '|');
};

/**
 * Returns normalized object with coordinate pairs as numbers from unknown location input
 * @param  {UnknownLocation} location
 * @return {Location}
 */
export const getLocation = (location: UnknownLocation): Location => {
  if (isString(location)) {
    const [lat, lng] = location.split(',');

    return { lat: parseFloat(lat), lng: parseFloat(lng) };
  }

  if (Object.prototype.hasOwnProperty.call(location, 'latitude') === true) {
    const { latitude: lat, longitude: lng } = location as FirebaseFirestore.GeoPoint;

    return { lat, lng };
  }

  if (Object.prototype.hasOwnProperty.call(location, 'lat') === true) {
    const { lat, lng } = location as Location;

    if (isFunction(lat) && isFunction(lng)) {
      return {
        lat: lat(),
        lng: lng(),
      };
    }

    return { lat, lng };
  }

  if (Object.prototype.hasOwnProperty.call(location, '_lat') === false) {
    const [lat, lng] = Object.values(location as UnderscoredLongLocation);

    return { lat: parseFloat(lat), lng: parseFloat(lng) };
  }

  const { _lat: lat, _long: lng } = location as UnderscoredShortLocation;

  return { lat, lng };
};
